import { FC } from 'react';
import { IDictionary, IOfferTemplate } from '@belong/types';
import { RichText } from '../../styles/Typography/RichText/RichText';
import Callout from '../Callout';
import { CONTAINER_STATE, CONTAINER_TEST_ID } from './constants';
import { OfferAlertWrapper, CalloutWrapper, OfferAlertWrapperPlain } from './OfferAlert.styles';

interface IOfferTemplateProps extends IOfferTemplate {
  extendedDictionary?: IDictionary;
}

export const OfferAlert: FC<IOfferTemplateProps> = ({ title, colour, description, extendedDictionary, code = '' }) => {
  const Wrapper = description ? OfferAlertWrapper : OfferAlertWrapperPlain;
  const offerId = extendedDictionary?.['offer:id'] ?? undefined;

  return (
    <Wrapper
      data-testid={CONTAINER_TEST_ID}
      data-offerid={offerId}
      data-templateid={code}
      data-state={CONTAINER_STATE.READY}
    >
      <CalloutWrapper>
        <Callout description={title} colour={colour} extendedDictionary={extendedDictionary} data-testid="callout" />
      </CalloutWrapper>
      {description && (
        <RichText
          {...description}
          h3="headingSmall"
          h2="headingSmall"
          p="copyMedium"
          alignment="left"
          dictionary={extendedDictionary}
          spacing="small"
        />
      )}
    </Wrapper>
  );
};

OfferAlert.displayName = 'OfferAlert';
